// TanStack Form surfaces validation errors as an array; zod-via-Standard-Schema
// entries are objects with a `message`. Render the first one only.
export function FieldError({ errors, id }: { errors: unknown[]; id?: string }) {
  if (!errors.length) return null;

  const first = errors[0];
  const message =
    typeof first === 'string'
      ? first
      : first && typeof first === 'object' && 'message' in first
        ? String((first as { message: unknown }).message)
        : '';

  if (!message) return null;

  return (
    <p id={id} role="alert" className="mt-1 text-sm text-destructive">
      {message}
    </p>
  );
}
